import $ from "jquery";
import config from "../config";
const URL_API = config.urlApi + "controller/getRandomPosts.php";

export default function getRandomPosts(formData) {
  return $.ajax({
    url: URL_API,
    type: "POST",
    data: formData,
    contentType: false,
    processData: false,
  });
}
